export default __webpack_public_path__ + "static/media/memphis-time-to-learn-with-blackboard-and-school-supplies.b72cd042.png";